// Analytics helpers derived from report open-details.
// The API only tracks opens (clicks/sent are not recorded), so everything
// here is built from opens[].{recipientId, timestamp}.

export const CHART_COLORS = [
  "#6366f1",
  "#22c55e",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#06b6d4",
  "#ec4899",
  "#84cc16",
];

export const openCountsByRecipient = (details = []) => {
  const m = {};
  details.forEach((d) => {
    if (d?.recipientId) m[d.recipientId] = (m[d.recipientId] || 0) + 1;
  });
  return m;
};

export const uniqueOpeners = (details = []) => {
  const s = new Set();
  details.forEach((d) => d?.recipientId && s.add(d.recipientId));
  return s.size;
};

// [{ date: 'YYYY-MM-DD', label: 'Sep 17', opens }]
export const opensByDay = (details = []) => {
  const m = {};
  details.forEach((d) => {
    if (!d?.timestamp) return;
    const day = new Date(d.timestamp).toISOString().slice(0, 10);
    m[day] = (m[day] || 0) + 1;
  });
  return Object.entries(m)
    .sort((a, b) => a[0].localeCompare(b[0]))
    .map(([date, opens]) => ({ date, label: formatDayLabel(date), opens }));
};

// 24 buckets, one per hour of day
export const opensByHour = (details = []) => {
  const arr = Array.from({ length: 24 }, (_, h) => ({
    hour: h,
    label: `${((h + 11) % 12) + 1}${h < 12 ? "a" : "p"}`,
    opens: 0,
  }));
  details.forEach((d) => {
    if (!d?.timestamp) return;
    const h = new Date(d.timestamp).getHours();
    if (arr[h]) arr[h].opens += 1;
  });
  return arr;
};

// How many contacts opened 1 / 2–3 / 4–5 / 6+ times
export const engagementBuckets = (counts = {}) => {
  const b = { "1×": 0, "2–3×": 0, "4–5×": 0, "6+×": 0 };
  Object.values(counts).forEach((c) => {
    if (c >= 6) b["6+×"] += 1;
    else if (c >= 4) b["4–5×"] += 1;
    else if (c >= 2) b["2–3×"] += 1;
    else b["1×"] += 1;
  });
  return Object.entries(b).map(([label, value]) => ({ label, value }));
};

export const formatDayLabel = (dateStr) => {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

// Date-range predicate shared by dashboard + report filters.
export const withinDateRange = (dateStr, preset, from, to) => {
  if (preset === "all" || !dateStr) return true;
  const d = new Date(dateStr);
  const now = new Date();
  if (preset === "custom") {
    if (from && d < new Date(from)) return false;
    if (to) {
      const end = new Date(to);
      end.setHours(23, 59, 59, 999);
      if (d > end) return false;
    }
    return true;
  }
  if (preset === "year") return d.getFullYear() === now.getFullYear();
  const days = { "7d": 7, "30d": 30, "90d": 90 }[preset];
  if (days) {
    const cutoff = new Date(now);
    cutoff.setDate(now.getDate() - days);
    return d >= cutoff;
  }
  return true;
};

export const DATE_PRESETS = [
  { value: "all", label: "All time" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "year", label: "This year" },
  { value: "custom", label: "Custom range" },
];
